export const queryKeys = {
  ONE_COMPAGING_CALL: "ONE_COMPAGING_CALL",
  CALLS_STATUS: "CALLS_STATUS",
  CALLS_DURATION: "CALLS_DURATION",
}